// extracted by mini-css-extract-plugin
module.exports = {"simulation":"Simulation_simulation__z8UYB","simulation__wrapper":"Simulation_simulation__wrapper__45oIP"};